<label [id]="dropdownId + '-label'" class="academy-dropdown__label">{{ dropdownLabel }}</label>
<div class="academy-dropdown">
  <button
    #triggerButton
    [id]="dropdownId + '-btn'"
    (click)="toggleDropdown()"
    type="button"
    class="academy-dropdown__trigger"
    aria-haspopup="listbox"
    [attr.aria-labelledby]="dropdownId + '-label ' + dropdownId + '-btn'"
    [attr.aria-expanded]="dropdownShown">
    <span class="academy-dropdown__value">{{ displayLabel }}</span>
    <span class="academy-dropdown__icon" [class.academy-dropdown__icon--open]="dropdownShown"></span>
  </button>

  @if (dropdownShown) {
    <ul
      class="academy-dropdown__options"
      role="listbox"
      [attr.aria-labelledby]="dropdownId + '-label'"
      tabindex="-1">
      @for (key of optionKeys; track key; let i = $index) {
        <li
          [id]="dropdownId + '-option-' + i"
          class="academy-dropdown__option"
          (click)="onOptionClick(key)"
          (keydown)="onOptionKeydown($event, key)"
          (blur)="onOptionBlur($event)"
          [class.academy-dropdown__option--selected]="key === model"
          role="option"
          [attr.aria-selected]="key === model"
          tabindex="-1">
          {{ options[key] }}
        </li>
      }
    </ul>
  }
</div>
